import styled, { css } from "styled-components";

const color = ({ $outline, theme }) => {
  if ($outline) return theme.colors.primary.cetaceanBlue;

  return theme.colors.neutral.black;
};

const backgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.primary.green;
};

const hoverBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return theme.colors.neutral.white;

  return theme.colors.hues.greenShade1;
};

const outline = ({ $outline, theme }) => {
  if ($outline) return `2px solid ${theme.colors.primary.cetaceanBlue} `;

  return "none";
};

const focusBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.primary.cetaceanBlue;
};

const focusOutline = ({ theme }) => {
  return `4px solid ${theme.colors.shade.vividTint2}`;
};

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px;
`;

export const SecondaryButtonStructure = css`
  color: ${color};
  font-weight: 700;
  background-color: ${backgroundColor};
  border: ${outline};

  &:hover:not([disabled]) {
    background-color: ${hoverBackgroundColor};
  }

  &:focus {
    background-color: ${focusBackgroundColor};
    outline: ${focusOutline};
  }
`;
